import React, { Component, Fragment } from "react";
import Modal from "react-bootstrap/lib/Modal";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CLORIAN_WIDGET_URL } from "../constants/api";
import { LanguageSelect } from "./LanguageSelect";

class ComponentModal extends Component {
  constructor(props) {
    super(props);

    this.handleLanguageChange = this.handleLanguageChange.bind(this);

    this.state = {
      copied: false,
      urlLang: "es",
    };
  }

  closeTheModal() {
    this.setState({ copied: false });
    this.props.closeModal();
  }

  handleLanguageChange(e) {
    this.setState({ urlLang: e.value, copied: false });
  }

  generateProductURL(clientHostName, sgId, prod, urlLang, clientUrlName) {
    let clientURL = clientHostName;
    if (process.env.REACT_APP_ENV !== "PROD") {
      clientURL = `${clientUrlName.toLowerCase()}-${process.env.REACT_APP_ENV.toLowerCase()}.clorian.com`;
    }

    const productUrl =
      clientURL +
      "/" +
      urlLang +
      "/" +
      +sgId +
      "/" +
      prod.productId +
      (prod.productCategory.general ? "" : "/info") +
      "?aff=";

    return productUrl;
  }

  generateModalMainBody(affWebsite, modalDetails, prodURL, currentHash) {
    const { copied, urlLang } = this.state;
    let modalObj = {};
    let utmVars = affWebsite
      ? "&utm_medium=afiliados&utm_campaign=Afiliados&utm_source=" +
        affWebsite.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "").split("/")[0]
      : "";

    //CHANGE TO A SWITCH!!!
    if (modalDetails.modalType === "linkModal") {
      modalObj.buttonText = copied ? " Copied" : " Copy Link";
      modalObj.clipboardText = "https://" + prodURL + currentHash + utmVars;
      modalObj.modalMainBody = (
        <samp>
          https://{prodURL}
          {currentHash}
          {utmVars}
        </samp>
      );
    } else if (modalDetails.modalType === "iFrameModal") {
      const iFrameSrc =
        `${CLORIAN_WIDGET_URL}?urlRedirect=` + prodURL + currentHash;
      modalObj.buttonText = copied ? "Code generated" : "Generate iframe code";
      modalObj.clipboardText =
        '<iframe src="' +
        iFrameSrc +
        utmVars +
        '" height=380px width=400px frameBorder="0" />';
      modalObj.modalMainBody = (
        <iframe
          className="iframeMod"
          src={iFrameSrc}
          frameBorder={0}
          title={modalDetails.modalTitle}
        />
      );
    } else if (modalDetails.modalType === "customUrls") {
      const links = modalDetails.customUrls;

      modalObj.modalMainBody = (
        <ul>
          {links.map((l, i) => {
            let linkObj = JSON.parse(l.itemLinkedUrl)[urlLang];
            let fullLink = linkObj + "?aff=" + currentHash + utmVars;

            const btnClass = copied[l.affiliateItemId]
              ? "btn-success"
              : "btn-primary";
            const btnText = copied[l.affiliateItemId] ? "Copied" : "Copy Link";

            return (
              <Fragment key={i}>
                <li>
                  <samp>{fullLink}</samp>
                </li>
                <div className="copyToClipboardDiv">
                  <CopyToClipboard
                    text={fullLink}
                    onCopy={() => this.copyCustomUrl(l.affiliateItemId)}
                  >
                    <button className={`btn btn-primary ${btnClass}`}>
                      <span className="glyphicon glyphicon-copy copyIcon"></span>
                      {btnText}
                    </button>
                  </CopyToClipboard>
                </div>
              </Fragment>
            );
          })}
        </ul>
      );
    } else if (modalDetails.modalType === "genericBanner") {
      modalObj.modalCss = "componentModalMain";
      modalObj.buttonText = copied
        ? "Image code generated"
        : "Generate image code";
      modalObj.clipboardText =
        "<a href='" +
        modalDetails.href[urlLang] +
        "?aff=" +
        currentHash +
        utmVars +
        "'><img src='" +
        modalDetails.imgSrc[urlLang] +
        "'/></a>";
      modalObj.modalMainBody = (
        <img src={modalDetails.imgSrc[urlLang]} alt="" />
      );
    } else if (modalDetails.modalType === "customBanners") {
      modalObj.modalCss = "componentModalMain";
      const bannerList = modalDetails.bannerList;

      modalObj.modalMainBody = (
        <ul>
          {bannerList.map((b, i) => {
            let imgSrc = JSON.parse(b.itemResource)[urlLang];
            const imgHref = JSON.parse(b.itemLinkedUrl)[urlLang];

            const btnClass = copied[b.affiliateItemId]
              ? "btn-success"
              : "btn-primary";
            const btnText = copied[b.affiliateItemId]
              ? "Code image generated"
              : "Generate image code";
            const clipboardText =
              "<a href='" +
              imgHref +
              "?aff=" +
              currentHash +
              utmVars +
              "'><img src='" +
              imgSrc +
              "'/></a>";

            return (
              <li key={i} className="customBannerLi">
                <img src={imgSrc} alt="" />
                <h4>{b.itemName}</h4>
                <div className="copyToClipboardDiv">
                  <CopyToClipboard
                    text={clipboardText}
                    onCopy={() => this.copyCustomUrl(b.affiliateItemId)}
                  >
                    <button className={`btn btn-primary ${btnClass}`}>
                      <span className="glyphicon glyphicon-copy copyIcon"></span>
                      {btnText}
                    </button>
                  </CopyToClipboard>
                </div>
              </li>
            );
          })}
        </ul>
      );
    }

    return modalObj;
  }

  copyCustomUrl(itemId) {
    let linkCopied = {};
    linkCopied[itemId] = true;
    let obj = { copied: linkCopied };
    this.setState(obj);
  }

  render() {
    const {
      modalDetails,
      showModal,
      affWebsite,
      languages,
      clientHostName,
      sgId,
      prod,
      currentHash,
      clientUrlName,
    } = this.props;
    const { urlLang, copied } = this.state;
    const btnClass = copied ? "btn-success" : "btn-primary";

    let prodURL;
    let modalObj;

    if (modalDetails.modalType !== "genericBanner") {
      prodURL = this.generateProductURL(
        clientHostName,
        sgId,
        prod,
        urlLang,
        clientUrlName
      );
      modalObj = this.generateModalMainBody(
        affWebsite,
        modalDetails,
        prodURL,
        currentHash
      );
    } else {
      modalObj = this.generateModalMainBody(
        affWebsite,
        modalDetails,
        null,
        currentHash
      );
    }

    return (
      <Modal
        show={showModal}
        onHide={() => this.closeTheModal()}
        dialogClassName={modalObj.modalCss}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <p>{modalDetails.modalTitle}</p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="componentModal">
          <Fragment>
            <LanguageSelect
              languages={languages}
              handleLanguageChange={(e) => this.handleLanguageChange(e)}
            />

            {modalObj.modalMainBody}

            {modalDetails.modalType !== "customUrls" &&
            modalDetails.modalType !== "customBanners" ? (
              <div className="copyToClipboardDiv">
                <CopyToClipboard
                  text={modalObj.clipboardText}
                  onCopy={() => this.setState({ copied: true })}
                >
                  <button className={`btn ${btnClass}`}>
                    <span className="glyphicon glyphicon-copy copyIcon"></span>
                    {modalObj.buttonText}
                  </button>
                </CopyToClipboard>
              </div>
            ) : (
              ""
            )}
          </Fragment>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ComponentModal;
